<template>
  <div class="fee-tip fee-tip-view">
    <div class="fee-tip__item one-row">
      <div class="fee-tip__item-field">
        <div>
          <span>是否挂车：{{ formData.is_trailer === 1 ? '是' : '否' }}；</span>
          <span>是否直播：{{ formData.is_lb === 1 ? '是' : '否' }}；</span>
          <span v-if="formData.pid">、是否保量：{{ formData.is_quantity === 'Y' ? '是' : '否' }}；</span>
          备注：{{ formData.remark || '-' }}。
        </div>
      </div>
    </div>
    <!--    含税收入公式      -->
    <div class="fee-tip__item one-row money-items">
      <div class="fee-tip__item-field">
        <div>{{ formData.adv_revenue|moneyFormat }}</div>
        <div>广告收入</div>
      </div>
      <div class="fee-tip__item-field">
        <div>{{ formData.exec_price|moneyFormat }}</div>
        <div>广告执行价</div>
      </div>
      <div class="fee-tip__item-field">
        <div>{{ formData.real_income|moneyFormat }}</div>
        <div>实际所得</div>
      </div>
      <div class="fee-tip__item-field">
        <div>{{ formData.cooperative_ori_price|moneyFormat }}</div>
        <div>合作原价</div>
      </div>
      <div v-if="isDouYinXT" class="fee-tip__item-field">
        <div>{{ formData.place_order_money|moneyFormat }}</div>
        <div>下单金额</div>
      </div>
      <div class="fee-tip__item-field">
        <div>{{ formData.payment_account|moneyFormat }}</div>
        <div>含税收入</div>
      </div>
      <div class="fee-tip__item-field">
        <div>{{ formData.rebates_amount|moneyFormat }}</div>
        <div>返点金额</div>
      </div>
      <div class="fee-tip__item-field">
        <div>{{ formData.rebates_rate|numberFormat(2) }}%</div>
        <div>返点比例</div>
      </div>
      <div class="fee-tip__item-field">
        <div>{{ formData.platform_fee_po|moneyFormat }}</div>
        <div>代下单平台费</div>
      </div>
      <div class="fee-tip__item-field">
        <div>{{ formData.weal_price|moneyFormat }}</div>
        <div>粉丝福利</div>
      </div>
      <div class="fee-tip__item-field">
        <div>{{ formData.authorized_price|moneyFormat }}</div>
        <div>授权价</div>
      </div>
      <div class="fee-tip__item-field">
        <div>{{ formData.invest_flow_fee|moneyFormat }}</div>
        <div>投流费</div>
      </div>
      <div class="fee-tip__item-field">
        <div>{{ formData.other_fee|moneyFormat }}</div>
        <div>其他费</div>
      </div>
      <div class="fee-tip__item-field">
        <div>{{ formData.pay_method || '--' }}</div>
        <div>支付方式</div>
      </div>
      <div class="fee-tip__item-field">
        <div>{{ formData.commission_trailer|numberFormat(2) }}%</div>
        <div>挂车佣金</div>
      </div>
      <div class="fee-tip__item-field">
        <div>{{ formData.cart_charges|moneyFormat }}</div>
        <div>购物车费用</div>
      </div>
      <div v-if="isRegularOrder" class="fee-tip__item-field">
        <div>{{ formData.offline_rebate|moneyFormat }}</div>
        <div>线下结佣</div>
      </div>
      <div class="fee-tip__item-field">
        <div>{{ formData.commission_rate|numberFormat(2) }}%</div>
        <div>直播佣金</div>
      </div>
      <div class="fee-tip__item-field">
        <div>{{ formData.cart_commission|moneyFormat }}</div>
        <div>直播坑位费</div>
      </div>
      <div v-permission="'view_money_achievement'" v-if="isPureLive !== true" class="fee-tip__item-field">
        <div>{{ formData.money_achievement|moneyFormat }}</div>
        <div>整单业绩金额</div>
      </div>
    </div>
    <div class="fee-tip__item one-row" style="justify-content: center;">
      <el-button round @click="toEdit">点击进入编辑模式</el-button>
    </div>
  </div>
</template>
<script>
export default {
  name: "OrderPartFeeView",
  components: {},
  props: {
    formData: {
      type: Object,
      required: true
    }
  },
  computed: {
    isDouYinXT() {
      // 是否包含抖音星图
      return Array.isArray(this.formData.platforms) && this.formData.platforms.includes('抖音星图')
    },
    isPureLive() {
      // 是“纯直播”
      const {isPureLive} = this.$route.query
      return isPureLive && isPureLive === 'true'
    },
    isRegularOrder() {
      let kind = this.$route.query.kind || ''
      if (!kind) {
        if (this.formData.pid || this.$route.query.source_id || this.formData.puke_id || this.isPureLive) {
          kind = ''
        } else {
          kind = 'RegularOrder'
        }
      }
      return kind === 'RegularOrder'
    }
  },
  methods: {
    toEdit: function () {
      this.$emit('to-edit')
    }
  }
}
</script>
<style lang="scss">
.fee-tip-view {
  padding: 24px 20px !important;
  width: 95% !important;
  margin: 5px auto !important;

  .money-items {
    display: grid !important;
    grid-template-columns: repeat(6, 1fr) !important;
    grid-gap: 12px;
    padding: 18px 48px !important;

    .fee-tip__item-field {

      div:first-child {
        font-size: 16px;
      }

      div:last-child {
        font-size: 14px;
      }
    }
  }
}
</style>
